import toast from 'react-hot-toast'

// Re-export toast functions with portal styling defaults
export const showToast = {
  success: (message: string) => {
    return toast.success(message, {
      className: 'portal-toast portal-toast-success',
    })
  },
  
  error: (message: string) => {
    return toast.error(message, {
      className: 'portal-toast portal-toast-error',
    })
  },
  
  loading: (message: string) => {
    return toast.loading(message, {
      className: 'portal-toast portal-toast-loading',
    })
  },
  
  info: (message: string) => {
    return toast(message, {
      icon: 'ℹ️',
      className: 'portal-toast portal-toast-info',
    })
  },
  
  warning: (message: string) => {
    return toast(message, {
      icon: '⚠️',
      className: 'portal-toast portal-toast-warning',
      style: {
        border: '1px solid rgba(245, 158, 11, 0.3)',
      },
    })
  },
  
  promise: <T,>(
    promise: Promise<T>,
    msgs: {
      loading: string
      success: string | ((data: T) => string)
      error: string | ((err: Error) => string)
    }
  ) => {
    return toast.promise(promise, msgs, {
      className: 'portal-toast',
    })
  },
  
  dismiss: toast.dismiss,
  remove: toast.remove,
}

// Common toast messages
export const toastMessages = {
  // Success messages
  saved: 'Changes saved successfully',
  created: 'Created successfully',
  updated: 'Updated successfully',
  deleted: 'Deleted successfully',
  copied: 'Copied to clipboard',
  sent: 'Sent successfully',
  
  // Error messages
  error: 'Something went wrong',
  networkError: 'Network error. Please check your connection',
  validationError: 'Please check your input and try again',
  permissionError: 'You do not have permission to perform this action',
  
  // Loading messages
  saving: 'Saving changes...',
  loading: 'Loading...',
  processing: 'Processing...',
  deleting: 'Deleting...',
  sending: 'Sending...',
}